'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import 'lodash.isempty';
import { NF_HEADER_SERVICE_TYPE, NF_HEADER_TYPE, NF_HEADER_SERVICE_INFO } from '../../constants/global.mjs';
import '../../utils/env.mjs';
import IcTxtDepthCategoryFinance from '../icons/IcTxtDepthCategoryFinance.mjs';
import IcTxtDepthCategoryInsurance from '../icons/IcTxtDepthCategoryInsurance.mjs';
import IcTxtDepthCategoryMyAsset from '../icons/IcTxtDepthCategoryMyAsset.mjs';
import IcTxtDepthCategoryRealEstate from '../icons/IcTxtDepthCategoryRealEstate.mjs';
import IcTxtDepthCategoryStock from '../icons/IcTxtDepthCategoryStock.mjs';
import IcTxtMainCategoryFinance from '../icons/IcTxtMainCategoryFinance.mjs';
import IcTxtMainCategoryMyAsset from '../icons/IcTxtMainCategoryMyAsset.mjs';
import IcTxtMainCategoryPay from '../icons/IcTxtMainCategoryPay.mjs';
import IcTxtMainCategoryRealEstate from '../icons/IcTxtMainCategoryRealEstate.mjs';
import IcTxtMainCategoryStock from '../icons/IcTxtMainCategoryStock.mjs';
import '../../constants/button.mjs';
import '../../constants/footer.mjs';
import '../../constants/footerQuickMenuItem.mjs';
import '../../constants/control.mjs';
import { getServiceUrl } from '../../utils/index.mjs';
import styles from './HeaderName.module.scss.mjs';

const cx = classNames.bind(styles);
const HEADER_MAIN_ICON = {
  [NF_HEADER_SERVICE_TYPE.MY_ASSET]: () => /*#__PURE__*/React.createElement(IcTxtMainCategoryMyAsset, {
    width: 60,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.PAYMENT]: () => /*#__PURE__*/React.createElement(IcTxtMainCategoryPay, {
    width: 35,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.FINANCE]: () => /*#__PURE__*/React.createElement(IcTxtMainCategoryFinance, {
    width: 37,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.STOCK]: () => /*#__PURE__*/React.createElement(IcTxtMainCategoryStock, {
    width: 36,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.REAL_ESTATE]: () => /*#__PURE__*/React.createElement(IcTxtMainCategoryRealEstate, {
    width: 56,
    height: 22
  })
};
const HEADER_DEPTH_ICON = {
  [NF_HEADER_SERVICE_TYPE.MY_ASSET]: () => /*#__PURE__*/React.createElement(IcTxtDepthCategoryMyAsset, {
    width: 46,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.FINANCE]: () => /*#__PURE__*/React.createElement(IcTxtDepthCategoryFinance, {
    width: 28,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.STOCK]: () => /*#__PURE__*/React.createElement(IcTxtDepthCategoryStock, {
    width: 28,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.REAL_ESTATE]: () => /*#__PURE__*/React.createElement(IcTxtDepthCategoryRealEstate, {
    width: 42,
    height: 22
  }),
  [NF_HEADER_SERVICE_TYPE.INSURANCE]: () => /*#__PURE__*/React.createElement(IcTxtDepthCategoryInsurance, {
    width: 26,
    height: 22
  })
};
const ICON_MAP = {
  [NF_HEADER_TYPE.MAIN]: HEADER_MAIN_ICON,
  [NF_HEADER_TYPE.DEPTH]: HEADER_DEPTH_ICON
};
const HeaderName = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    href,
    headerType,
    serviceType,
    ...props
  } = _ref;
  const text = NF_HEADER_SERVICE_INFO[serviceType].text;
  const Icon = ICON_MAP[headerType][serviceType];
  return /*#__PURE__*/React.createElement("a", {
    href: href || getServiceUrl(serviceType),
    className: cx('article'),
    ...props,
    ref: ref
  }, /*#__PURE__*/React.createElement(Icon, null), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, text));
});
HeaderName.displayName = 'HeaderName';

export { HeaderName as default };
